/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Diet_EyebrowInputs */

const en_portal_diet_eyebrow = /** @type {(inputs: Portal_Diet_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diet`)
};

const pl_portal_diet_eyebrow = /** @type {(inputs: Portal_Diet_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieta`)
};

/**
* | output |
* | --- |
* | "Diet" |
*
* @param {Portal_Diet_EyebrowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_diet_eyebrow = /** @type {((inputs?: Portal_Diet_EyebrowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Diet_EyebrowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_diet_eyebrow(inputs)
	return en_portal_diet_eyebrow(inputs)
});